import React from 'react';
import styled from 'styled-components';
import { Row, Col, Select } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Text } from '@/components/Typography';

export const Selector = styled(Select)`
	min-width: 3.5rem;

	.ant-select-selector {
		border: 1px solid #e6e6e6;
		border-radius: 5px !important;
	}

	.ant-select-arrow {
		width: 10px;
		color: #262626;
	}
`;

interface PageSelectorProps {
	defaultValue?: number;
	onChange: (value: number) => void;
}

export const PageSelector = ({ defaultValue = 1, onChange }: Readonly<PageSelectorProps>) => {
	const options = [5, 10, 20, 30, 50, 100].map((value) => ({
		label: value.toString(),
		value
	}));

	return (
		<Row gutter={[12, 0]} align="middle">
			<Col>
				<Text>{I18n.get('Items per page')}</Text>
			</Col>
			<Col>
				<Selector defaultValue={defaultValue} options={options} onChange={(value) => onChange(Number(value))} />
			</Col>
		</Row>
	);
};
